exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kb-neptune-widget-title-2-TP2P{font-weight:600;margin:25px 0 10px}", ""]);
